import { Badge } from '../Badge';
import { Button } from '../Button';
import { Action, Card, Copy, Message } from './UpgradeOfferCard.styles';
import type { UpgradeOfferCardProps } from './UpgradeOfferCard.types';

export function UpgradeOfferCard({
  badge,
  message,
  actionLabel,
  onAction,
  actionAriaLabel,
  disabled,
  className,
}: UpgradeOfferCardProps) {
  return (
    <Card className={className}>
      <Copy>
        <Badge tone="brand">{badge}</Badge>
        <Message>{message}</Message>
      </Copy>
      <Action>
        <Button
          type="button"
          variant="neutral"
          onClick={onAction}
          aria-label={actionAriaLabel}
          disabled={disabled}
        >
          {actionLabel}
        </Button>
      </Action>
    </Card>
  );
}
